import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { WorkflowsComponent } from '../../workflows/workflows.component';
import { SideNavComponent } from '../side-nav/side-nav.component';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [CommonModule, WorkflowsComponent, RouterModule, SideNavComponent],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {

}
